/**
 * Section card — the mockup's `.card` with its `.hd` header and `.src` badge.
 *
 * Sections previously ran together as unlabelled blocks, so nothing said where any
 * of it came from. That matters here more than it looks: a job title from Azure AD
 * and a bio somebody typed carry very different authority, and the profile is
 * exactly where people decide whether to trust a field. The `.src` badge names the
 * source per card — Vantagepoint, Azure AD, self-reported, or automatic.
 *
 * Geometry from the mockup: surface card, 1px line, e1, header on --surface-2 with
 * 10.5px uppercase 0.09em, body padding 13px 14px.
 */

const SOURCE_STYLES = {
  self: 'bg-accent-soft text-accent border-accent-line',
  vp: 'bg-surface-2 text-ink-2 border-line-strong',
  aad: 'bg-surface-2 text-ink-2 border-line-strong',
  auto: 'bg-surface-2 text-ink-2 border-line-strong',
};

const SOURCE_LABELS = {
  self: 'Self-reported',
  vp: 'Vantagepoint',
  aad: 'Azure AD',
  auto: 'Automatic',
};

export function ProfileCard({ title, source, action, children, bodyClassName = '', allowOverflow = false }) {
  return (
    <div className={`rounded-card bg-surface border border-line shadow-e1 ${allowOverflow ? 'overflow-visible' : 'overflow-hidden'}`}>
      <div className="flex items-center gap-[9px] px-3.5 py-2.5 border-b border-line bg-surface-2">
        <h5 className="text-[10.5px] font-bold uppercase tracking-[0.09em] text-ink-3 m-0">
          {title}
        </h5>
        {action}
        {source && (
          <span
            className={`ml-auto text-[9.5px] font-bold uppercase tracking-[0.04em] px-1.5 py-0.5
                        rounded border whitespace-nowrap ${SOURCE_STYLES[source]}`}
            title={
              source === 'self'
                ? 'Entered by this person — they can change it in Edit Profile'
                : source === 'auto'
                  ? 'Derived automatically, not entered by anyone'
                  : `Comes from ${SOURCE_LABELS[source]} and cannot be edited here`
            }
          >
            {SOURCE_LABELS[source]}
          </span>
        )}
      </div>
      <div className={`px-3.5 py-[13px] ${allowOverflow ? 'overflow-visible' : ''} ${bodyClassName}`}>{children}</div>
    </div>
  );
}
